import React, { useState, useEffect } from "react";
import axios from "axios";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { connect } from "react-redux";
import Button from "@material-ui/core/Button";
import * as actions from "../../redux/actions";
import { staticsUrl } from "../../config";
import Autocomplete from "@material-ui/lab/Autocomplete";
import clsx from "clsx";
// import { showSpinner, hideSpinner } from '../../redux/actions';
import {
  getCourses,
  getCourseIds,
  getCourseSections,
  getSection,
  getGameset,
  getExercise,
  getExerciseImages,
  getSectionHistoryImages,
  getCourseHistoryImages,
  getAllHistoryImages,
} from "../../redux/actions/crawler";
const devApi = axios.create({
  baseURL: "http://127.0.0.1:3000/xapi",
});

const useStyles = makeStyles((theme) => ({
  config: {
    marginBottom: 8,
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    position: "relative",
    "& button": {
      marginRight: 8,
    },
  },
  imgWrap: {
    position: "absolute",
    top: 0,
    right: 0,
    width: 200,
    "& img": {
      width: "100%",
    },
  },
  container: {
    paddingTop: 16,
    marginBottom: 8,
  },
  textFiled: {
    width: 130,
    marginRight: 8,
  },
  title: {
    marginTop: 8,
    marginBottom: 8,
  },
}));

const asyncForEach = async (array, callback) => {
  if (!array) return;
  for (let index = 0; index < array.length; index++) {
    await callback(array[index], index, array);
  }
};

let continueCrawing = true;
const five = [
  "/resources/storyElementImage/7/it%20is%20mark%27s%20first.jpg",
  "/resources/storyElementImage/8/and%20he%20is%20very%20excited.jpg",
  "/resources/storyElementImage/9/he%20walks%20down%20the%20street.jpg",
  "/resources/storyElementImage/10/he%20has%20black%20hair%20and%20brown%20eyes.jpg",
  "/resources/storyElementImage/11/he%20looks%20around.jpg",
];

const ten = [
  "/resources/storyElementImage/7/it%20is%20mark%27s%20first.jpg",
  "/resources/storyElementImage/8/and%20he%20is%20very%20excited.jpg",
  "/resources/storyElementImage/9/he%20walks%20down%20the%20street.jpg",
  "/resources/storyElementImage/10/he%20has%20black%20hair%20and%20brown%20eyes.jpg",
  "/resources/storyElementImage/11/he%20looks%20around.jpg",
  "/resources/storyElementImage/12/at%20the%20buildings.jpg",
  "/resources/storyElementImage/13/he%20turns%20the%20corner.jpg",
  "/resources/storyElementImage/14/and%20sees%20a%20woman%20with%20a%20white%20dog.jpg",
  "/resources/storyElementImage/15/mark%20likes%20dogs%20so%20he%20stops.jpg",
  "/resources/storyElementImage/16/he%20picks%20up%20his%20luggae.jpg",
];

function HistoryCache(props) {
  const classes = useStyles();
  const [consol, setConsol] = useState("");
  const [base64, setBase64] = useState();
  const [size, setSize] = useState(500);
  const [quality, setQuality] = useState(25);
  const [courses, setCourses] = useState([]);
  const [course, setCourse] = useState(null);
  const [imageList, setImageList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentNo, setCurrentNo] = useState(0);
  const [imagesSent, setImagesSent] = useState(false);
  const percent = imageList.length
    ? parseInt((currentNo / imageList.length) * 100)
    : 0;
  const [cachedImages, setCachedImages] = useState(null);

  useEffect(() => {
    refresh();
    // eslint-disable-next-line
  }, []);

  const refresh = () => {
    loadConfig();
    loadCourses();
    loadCachedImages();
  };

  const loadCourses = async () => {
    try {
      const courses = await getCourses();
      setCourses([{ id: 0, title: "All" }, ...courses]);
    } catch (err) {
      props.notify("Error loading courses.");
    }
  };

  const preloadSound = (img) => {
    const src = img;
    const sound = document.createElement("audio");
    if ("src" in sound) {
      sound.autoPlay = false;
      sound.preload = "auto";
    }
    sound.src = src;
    document.body.appendChild(sound);
    return sound;
  };

  const toConsole = (data) => {
    if (typeof data === "object")
      return setConsol(JSON.stringify(data, null, 2));
    if (typeof data === "string") return setConsol(data);
  };

  const getImgFromApi = (imgUrl) => {
    const url = staticsUrl + imgUrl;
    return axios.get(url, { responseType: "arraybuffer" });
  };

  const sendImgToDevApi = (buffer, path) => {
    const data = {
      data: buffer.toString("base64"),
      path,
    };
    return devApi.patch("/upload/history", data);
  };

  const sendImages = async () => {
    continueCrawing = true;
    setImagesSent(false);
    setLoading(true);
    let no = 1;
    await asyncForEach(imageList, async (imgUrl) => {
      setCurrentNo(no++);
      if (!continueCrawing) return;
      const response = await getImgFromApi(imgUrl);
      const buffer = Buffer.from(response.data, "binary");
      await sendImgToDevApi(buffer, imgUrl);
      setBase64(buffer.toString("base64"));
    });
    setLoading(false);
    setImagesSent(true);
    setTimeout(() => {
      saveHistory();
    }, 1500);
  };

  const saveDefaultConfig = () => {
    const config = { size: 500, quality: 25 };
    devApi.post("/config", config);
  };

  const loadConfig = () => {
    devApi.get("/config").then((res) => {
      const config = res.data;
      let valid = true;
      if (!config || !config.size || !config.quality) valid = false;
      if (valid) {
        setSize(config.size);
        setQuality(config.quality);
      } else {
        props.notify("Error loading config", "error");
      }
    });
  };

  const saveConfig = async () => {
    const config = { size, quality };
    try {
      await devApi.post("/config", config);
      props.notify("Config saved", "success");
    } catch (err) {
      props.notify("Error saving config", "error");
    }
  };

  const removeAll = async () => {
    if (!window.confirm("Are you sure you want to erase all History Cache?"))
      return;
    try {
      await devApi.delete("/upload/history");
      props.notify("History deleted", "info");
    } catch (err) {
      console.log(err);
      props.notify("Error removing files", "error");
    }
    setImagesSent(false);
  };

  const handleSizeChange = (ev) => {
    let val = parseInt(ev.target.value);
    val = Math.min(val, 1000);
    val = Math.max(1, val);
    setSize(val);
  };

  const handleQualityChange = (ev) => {
    let val = parseInt(ev.target.value);
    val = Math.min(val, 100);
    val = Math.max(1, val);
    setQuality(val);
  };

  const getImageList = async () => {
    let imageList;
    props.showSpinner("Loading course images");
    try {
      if (course.id) {
        imageList = await getCourseHistoryImages(course.id);
      } else {
        imageList = await getAllHistoryImages();
      }
      toConsole(imageList);
      setImageList(imageList);
    } catch (err) {
      props.notify("Error getting images", "error");
    }
    props.hideSpinner();
  };

  const loadFive = () => {
    setImageList(five);
    toConsole(five);
    setImagesSent(false);
  };

  const loadTen = () => {
    setImageList(ten);
    toConsole(ten);
    setImagesSent(false);
  };

  const saveHistory = async () => {
    try {
      await devApi.post("/upload/history");
      props.notify("History saved", "success");
      loadCachedImages();
    } catch (err) {
      console.log(err);
      props.notify("Error History not saved", "error");
    }
    setImagesSent(false);
  };

  const loadCachedImages = () => {
    devApi.get("/upload/history").then((res) => {
      setCachedImages(res.data);
    });
  };

  const filterPresentImages = () => {
    const images = [];
    const existing = [];
    imageList.forEach((path) => {
      if (!cachedImages[path]) {
        images.push(path);
      } else {
        existing.push(path);
      }
    });
    setImageList(images);
    toConsole(images);
  };

  const get100 = () => {
    const newImages = imageList.splice(0, 100);
    setImageList(newImages);
    toConsole(newImages);
  };

  const removeFirst = () => {
    const newImages = [...imageList];
    const removed = newImages.shift();
    setImageList(newImages);
    toConsole(newImages);
  };

  return (
    <div className={clsx("container", classes.container)}>
      <h3 className={classes.title}>Config</h3>
      <div className={classes.config}>
        <TextField
          value={size}
          onChange={handleSizeChange}
          label="Size"
          type="number"
          variant="outlined"
          size="small"
          className={classes.textFiled}
          error={size < 150 || size > 800}
        />
        <TextField
          value={quality}
          onChange={handleQualityChange}
          label="Quality"
          type="number"
          variant="outlined"
          size="small"
          className={classes.textFiled}
        />
        <Button variant="contained" onClick={saveConfig} color="primary">
          Save Config
        </Button>
        <div className={classes.imgWrap}>
          <p>
            {currentNo}/{imageList.length} - {percent}%
          </p>
          <img src={`data:image/jpeg;charset=utf-8;base64,${base64}`} />
        </div>
      </div>
      <h3 className={classes.title}>Courses</h3>
      <div className={classes.config}>
        <Autocomplete
          options={courses}
          getOptionLabel={(option) => option.title}
          style={{ width: 350, display: "inline-block", marginRight: 8 }}
          value={course}
          onChange={(ev, val) => setCourse(val)}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Course"
              variant="outlined"
              size="small"
            />
          )}
        />
        <Button
          variant="contained"
          onClick={getImageList}
          color="primary"
          disabled={!course}
        >
          Get Image List
        </Button>
        {/* <Button variant="contained" onClick={loadFive} color="primary">5</Button>
        <Button variant="contained" onClick={loadTen} color="primary">10</Button> */}
        <Button
          variant="contained"
          onClick={filterPresentImages}
          color="primary"
        >
          Filter existing images
        </Button>
        <Button variant="contained" onClick={get100} color="primary">
          Get 100
        </Button>
        <Button variant="contained" onClick={removeFirst} color="primary">
          Remove First
        </Button>
      </div>
      {imageList.length > 0 && (
        <span style={{ marginLeft: 16 }}>Loaded {imageList.length} images</span>
      )}
      <h3>Actions</h3>
      <div className={classes.config}>
        <Button
          variant="contained"
          onClick={sendImages}
          color="primary"
          disabled={!imageList.length}
        >
          Send Images
        </Button>
        <Button
          variant="contained"
          onClick={() => (continueCrawing = false)}
          color="primary"
          disabled={!loading}
        >
          Break
        </Button>
        <Button
          variant="contained"
          onClick={removeAll}
          color="primary"
          disabled={loading}
        >
          Remove All
        </Button>
        <Button
          variant="contained"
          onClick={refresh}
          color="primary"
          disabled={loading}
        >
          Refresh
        </Button>
        <Button variant="contained" onClick={saveHistory} color="primary">
          Save History
        </Button>
      </div>
      <textarea
        value={consol}
        style={{ width: "100%", height: 350 }}
        onChange={() => {}}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  const { auth, notes, config, messages, userState, tools } = state;
  return { auth, notes, config, messages, userState, tools };
};

export default connect(mapStateToProps, actions)(HistoryCache);
